import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'calsoft-plan-compare-type15',
  templateUrl: './plan-compare-type15.component.html',
  styleUrls: ['./plan-compare-type15.component.scss']
})
export class PlanCompareType15Component {

  @Input() item: any;
  @Input() data: any;
  pricedetail:any;
  price_detail:any;  
  items:any;
  constructor() {

  }
  
  ngOnInit() {  
    this.pricedetail = JSON.parse(this.item.customField30);
   this.price_detail = this.pricedetail.pricedetail;    
  //  this.price_detail = JSON.parse(this.item.customField30.pricedetail);
   this.price_detail[0].open = true;
           console.log(this.pricedetail)
    console.log(this.pricedetail.pricedetail)
  }      

 
  toggleSection(i) {
    if(this.price_detail[i].list_detail.length >0){
      this.price_detail[i].open = !this.price_detail[i].open;
    }
  }

    toggleExpand(data: any) {
    data.expanded = !data.expanded;
  }


}
